import { Chip } from "@heroui/react";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { UserRole } from "@/api/userRoles/userRoles.ts";
import { useAppSelector } from "@/hooks/useAppSelector.ts";

export function RoleChip({ roleId }: { roleId: number }) {
  const [item, setItem] = useState<UserRole | null>(null);
  const items = useAppSelector((state) => state.handbooks.userRole);

  useEffect(() => {
    if (roleId === -1) {
      setItem(null);
    } else {
      setItem(items.find((el) => el.id == roleId) || null);
    }
  }, [roleId, items]);

  return (
    <>
      {roleId === -1 && (
        <Chip variant="dot" color="danger">
          удалено
        </Chip>
      )}
      {roleId !== -1 && item !== null && (
        <Chip
          as={Link}
          to={"/dashboard/userRoles"}
          variant="dot"
          color="primary">
          {item?.name}
        </Chip>
      )}
      {roleId !== -1 && item == null && (
        <Chip variant="dot" color="default">
          н/д
        </Chip>
      )}
    </>
  );
}
